// extracted by mini-css-extract-plugin
export default {"videoActionsContainer":"ActionButtons_videoActionsContainer__hQGn0","btn":"ActionButtons_btn__buXrm","icon":"ActionButtons_icon__8K3n8"};